import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { JustificationsReverseLogistics } from 'contracts/JustificationsReverseLogistics';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_JUSTIFICATION_REVERSE_LOGISTICS_',
  }
);

export interface FetchJustificationReverseLogisticsState {
  data: JustificationsReverseLogistics | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchJustificationReverseLogisticsRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: JustificationsReverseLogistics;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchJustificationReverseLogisticsState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchJustificationReverseLogisticsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchJustificationReverseLogisticsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchJustificationReverseLogisticsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchJustificationReverseLogisticsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchJustificationReverseLogistics = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchJustificationReverseLogisticsTypes = Types;
export const FetchJustificationReverseLogisticsActions = Creators;
